export const brandInfo = {
  name: '豆花视频',
  englishName: 'Douhua Video',
  slogan: '发现精彩，畅享高清',
  founded: '2020年',
  headquarters: '北京市朝阳区望京科技园',
  description: '豆花视频是国内领先的正版高清视频内容平台，致力于为用户提供丰富、优质、多元化的视频内容服务。自2020年创立以来，豆花视频始终秉持"内容为王、用户至上"的理念，通过先进的技术平台和优质的内容生态，为数千万用户带来了极致的视听体验。',
  mission: '让每个人都能轻松发现和享受高品质的视频内容，连接创作者与观众，共同构建繁荣的视频内容生态。',
  vision: '成为全球华语用户首选的视频内容平台，推动中国视频产业的创新与发展。',
  values: [
    { title: '内容为王', description: '始终坚持正版内容，为用户提供高品质的视频体验' },
    { title: '技术创新', description: '持续投入技术研发，以AI驱动内容推荐和用户体验优化' },
    { title: '用户至上', description: '倾听用户声音，不断优化产品，满足用户多元化需求' },
    { title: '合作共赢', description: '与内容创作者、版权方建立长期共赢的合作关系' },
  ],
  stats: [
    { label: '注册用户', value: '5000万+', icon: 'ri-user-line' },
    { label: '日活用户', value: '1200万+', icon: 'ri-fire-line' },
    { label: '内容总量', value: '10万+小时', icon: 'ri-film-line' },
    { label: '合作伙伴', value: '3000+', icon: 'ri-group-line' },
  ],
  contact: {
    address: '北京市朝阳区望京科技园A座18层',
    phone: '400-888-6666',
    email: 'service@douhuavideo.com',
    wechat: '豆花视频官方',
    businessHours: '周一至周日 9:00 - 21:00',
  },
};

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20business%20casual%2C%20soft%20lighting%2C%20professional%20headshot&width=100&height=100&seq=douhua-avatar-1&orientation=squarish',
    role: '资深影迷',
    content: '豆花视频的画质真的没话说，4K高清看大片太爽了！而且更新速度很快，新片上映没几天就能看到了。已经成为我每天的必备App。',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20warm%20smile%2C%20clean%20white%20background%2C%20modern%20casual%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=100&height=100&seq=douhua-avatar-2&orientation=squarish',
    role: '全职妈妈',
    content: '给孩子找动画片很方便，分类清晰，还有专门的儿童模式。关键是内容都是正版的，给孩子看不担心，画面也保护眼睛。',
    rating: 5,
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=100&height=100&seq=douhua-avatar-3&orientation=squarish',
    role: '大学生',
    content: '纪录片资源太丰富了！我喜欢看自然和科技类的纪录片，豆花视频上的资源比很多平台都全，而且没有广告打扰，体验很好。',
    rating: 5,
  },
  {
    id: 4,
    name: '刘总',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20businessman%20portrait%2C%20confident%20smile%2C%20clean%20white%20background%2C%20formal%20attire%2C%20soft%20professional%20lighting%2C%20headshot&width=100&height=100&seq=douhua-avatar-4&orientation=squarish',
    role: '企业管理者',
    content: '出差路上就靠豆花视频打发时间了。离线下载功能很实用，在飞机上也能看。推荐算法也很精准，总能找到我喜欢的内容。',
    rating: 5,
  },
];

export const faqList = [
  {
    question: '豆花视频是否免费？',
    answer: '豆花视频提供丰富的免费内容供用户观看。同时，我们也提供会员服务，会员用户可以享受更高画质（4K超清）、免广告、独家内容、离线下载等高级权益。新用户注册即可获得7天免费会员体验。',
  },
  {
    question: '如何在豆花视频上观看高清内容？',
    answer: '豆花视频支持从标清到4K超清多种画质选择。您可以在播放器右下角的设置中选择所需的画质。更高的画质需要更稳定的网络环境，建议在WiFi环境下观看4K内容。会员用户可享受全部画质选择。',
  },
  {
    question: '豆花视频支持哪些设备？',
    answer: '豆花视频全面支持各种主流设备：通过浏览器访问官网即可在电脑上观看；手机和平板用户可以在各大应用商店下载豆花视频App（支持iOS和Android系统）；同时我们还支持智能电视和电视盒子设备，让您在大屏幕上享受视听盛宴。',
  },
  {
    question: '如何成为豆花视频的内容创作者？',
    answer: '豆花视频欢迎优质内容创作者加入我们的平台。您可以通过官网的"创作者中心"提交入驻申请，我们的内容审核团队会在3个工作日内完成审核。通过审核后，您就可以上传内容并获得平台的流量支持和收益分成。',
  },
  {
    question: '豆花视频的内容是否为正版？',
    answer: '是的，豆花视频始终坚持正版内容路线。平台上所有影视、综艺、纪录片等内容均已获得版权方的合法授权。我们与国内外数百家影视制作公司和版权机构建立了长期合作关系，确保为用户提供合法、优质的内容服务。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您在使用过程中遇到播放卡顿、无法加载等问题，建议首先检查网络连接状态。如问题仍未解决，可以尝试清除浏览器缓存或重启App。您也可以随时联系我们的客服团队（电话：400-888-6666），我们会尽快为您解决问题。',
  },
];